{
  "close": "Sluiten",
  "phase": {
    "agent_running": "Bezig",
    "awaiting_user_input": "Wacht op jou",
    "idle_active": "Inactief",
    "turn_budget_exhausted": "Budget bereikt",
    "paused": "Gepauzeerd"
  },
  "taskStatus": {
    "todo": "Te doen",
    "progress": "Bezig",
    "done": "Klaar",
    "blocked": "Geblokkeerd",
    "failed": "Mislukt"
  },
  "composer": {
    "placeholder": "Stuur een bericht aan het team…",
    "placeholderPaused": "Stuur een bericht om de ruimte te starten…"
  },
  "rooms": {
    "title": "Ruimtes",
    "description": "Ruimtes waarin een team van agents samen aan jouw doel werkt, met jou aan boord.",
    "new": "Nieuwe ruimte",
    "search": "Ruimtes zoeken…",
    "open": "Openen",
    "rename": "Naam wijzigen",
    "duplicate": "Dupliceren",
    "delete": "Ruimte verwijderen",
    "deleteTitle": "Deze ruimte verwijderen?",
    "deleteDescription": "“{{title}}” en het gesprek, de taken en bestanden worden definitief verwijderd. Lopende beurten worden geannuleerd.",
    "deleted": "Ruimte verwijderd",
    "created": "Ruimte aangemaakt",
    "duplicated": "“{{title}}” aangemaakt (gepauzeerd)",
    "untitled": "Ruimte #{{id}}",
    "noTeam": "Geen team",
    "allTeams": "Alle teams",
    "allStatuses": "Alle statussen",
    "filterTeam": "Filteren op team",
    "filterStatus": "Filteren op status",
    "emptyTitle": "Nog geen ruimtes",
    "emptyDescription": "Start een ruimte vanuit een team en geef het een doel; de teamleider plant en verdeelt het werk.",
    "emptyShort": "Nog geen ruimtes",
    "noMatches": "Geen ruimtes gevonden voor “{{query}}”",
    "columns": {
      "room": "Ruimte",
      "status": "Stand",
      "turns": "Beurten",
      "activity": "Laatste activiteit",
      "created": "Aangemaakt"
    }
  },
  "newRoom": {
    "title": "Nieuwe ruimte",
    "description": "Kies een team; de leden komen als medewerkers in de ruimte. De ruimte staat gepauzeerd tot je het eerste bericht stuurt.",
    "submit": "Ruimte aanmaken",
    "team": "Werkteam",
    "teamHint": "Een team heeft precies één leider en een model voor elk lid nodig.",
    "teamPlaceholder": "Kies een team…",
    "members_one": "{{count}} lid",
    "members_other": "{{count}} leden",
    "notReady": "Niet gereed",
    "name": "Naam",
    "namePlaceholder": "bijv. Marktonderzoek Q3",
    "noTeamsTitle": "Nog geen teams",
    "noTeamsManage": "Maak eerst een team met een leider aan en start er dan ruimtes mee.",
    "noTeamsAsk": "Vraag een beheerder om een team aan te maken voordat je een ruimte start.",
    "openTeams": "Teams openen"
  },
  "room": {
    "title": "Ruimte",
    "nameLabel": "Naam van de ruimte",
    "rename": "Ruimte hernoemen",
    "actions": "Acties voor ruimte",
    "panel": "Details van de ruimte",
    "showPanel": "Details tonen",
    "hidePanel": "Details verbergen",
    "reconnecting": "Verbinding verbroken — opnieuw verbinden…",
    "turns_one": "{{count}} beurt",
    "turns_other": "{{count}} beurten",
    "turnsOf_one": "{{count}} van {{budget}} beurten",
    "turnsOf_other": "{{count}} van {{budget}} beurten",
    "tabs": {
      "tasks": "Taken",
      "plan": "Planning",
      "team": "Bezetting",
      "files": "Bestanden",
      "search": "Zoeken"
    },
    "state": {
      "paused": "De ruimte is gepauzeerd. Stuur een bericht of hervat om verder te gaan.",
      "budget": "Beurtbudget bereikt ({{used}} van {{budget}}). Verhoog het in de instellingen om verder te gaan.",
      "running_one": "{{names}} is bezig…",
      "running_other": "{{names}} zijn bezig…",
      "runningUnknown": "Het team gaat aan de slag…",
      "yourTurn": "Het team wacht op jouw antwoord.",
      "idle": "Het team is inactief. Stuur een bericht of laat de leider een stap zetten."
    },
    "control": {
      "pause": "Pauzeren",
      "resume": "Hervatten",
      "step": "Stap: laat de leider een beurt nemen",
      "stepRequested": "De leider neemt een beurt",
      "stop": "Alle activiteit stoppen",
      "stopTitle": "De ruimte stoppen?",
      "stopDescription": "Lopende beurten worden geannuleerd, werk in de wachtrij vervalt en de ruimte wordt gepauzeerd.",
      "stopped": "Ruimte gestopt",
      "cancel": "Lopende beurten annuleren",
      "cancelTitle": "Lopende beurten annuleren?",
      "cancelDescription": "Medewerkers die nu nadenken stoppen; de ruimte zelf blijft actief.",
      "cancelled_one": "{{count}} beurt geannuleerd",
      "cancelled_other": "{{count}} beurten geannuleerd"
    },
    "export": {
      "copy": "Kopiëren als Markdown",
      "download": "Downloaden als Markdown",
      "copied": "Gesprek gekopieerd"
    },
    "memory": {
      "title": "Geheugen",
      "compress": "Geheugen comprimeren",
      "compressed": "Oudere berichten zijn samengevat",
      "nothingToCompress": "Nog niets om te comprimeren",
      "summary": "Doorlopende samenvatting",
      "noSummary": "Nog geen samenvatting. Oudere berichten worden samengevat zodra de ruimte {{count}} berichten passeert.",
      "disabled": "Compressie staat uit: agents zien alleen de meest recente berichten."
    },
    "tasks": {
      "emptyTitle": "Nog geen taken",
      "emptyDescription": "De leider maakt taken aan en wijst ze toe aan teamleden zodra het werk gepland is.",
      "progress": "{{done}} van {{total}} klaar",
      "unassigned": "Niet toegewezen",
      "created": "Aangemaakt",
      "started": "Gestart",
      "completed": "Afgerond",
      "description": "Beschrijving",
      "instructions": "Instructies",
      "expectedOutput": "Verwachte uitkomst",
      "error": "Fout",
      "resultSummary": "Resultaat",
      "result": "Resultaatgegevens",
      "finishedToast": "{{name}} heeft “{{title}}” afgerond",
      "failedToast": "{{name}} kon “{{title}}” niet afronden"
    },
    "context": {
      "plan": "Planning",
      "planEmpty": "De leider schrijft hier het plan zodra het werk is opgedeeld.",
      "planUpdates_one": "{{count}} planupdate",
      "planUpdates_other": "{{count}} planupdates",
      "notes": "Gedeelde notities",
      "addPlaceholder": "Voeg een notitie toe voor het team…",
      "addHint": "Elke agent ziet deze notities in zijn context.",
      "add": "Notitie toevoegen",
      "added": "Notitie toegevoegd",
      "text": "Tekst van de notitie",
      "delete": "Notitie verwijderen",
      "deleteTitle": "Deze notitie verwijderen?",
      "deleteDescription": "Agents zien de notitie dan niet meer in hun context.",
      "deleted": "Notitie verwijderd",
      "byAgent": "door een agent",
      "byPerson": "door een persoon",
      "guardrails": "Vangrails",
      "guardrailsEmpty": "Geen regels voor deze ruimte. Voeg ze toe in de instellingen.",
      "category": {
        "goal": "Doel",
        "guardrail": "Vangrail",
        "data_source": "Gegevensbron",
        "discussion": "Discussie",
        "task_status": "Planning",
        "other": "Overig"
      }
    },
    "workers": {
      "fromTeam": "Leden van {{team}}",
      "noTeam": "Het team is verwijderd; de bezetting blijft behouden.",
      "editTeam": "Team bewerken",
      "empty": "Geen medewerkers in deze ruimte",
      "leader": "Leider",
      "nextUp": "Is aan de beurt",
      "agent": "AI-agent",
      "simple": "Eenvoudig lid",
      "member": "Een lid",
      "formerMember": "Voormalig lid",
      "role": "Rol",
      "workingOn": "Werkt aan {{title}}",
      "status": {
        "thinking": "Denkt na",
        "idle": "Inactief",
        "despawned": "Verwijderd"
      },
      "despawn": "{{name}} uit de ruimte verwijderen",
      "despawnConfirm": "Uit ruimte verwijderen",
      "despawnTitle": "{{name}} verwijderen?",
      "despawnDescription": "De medewerker stopt, open taken gaan terug naar de leider en hij neemt geen beurten meer in deze ruimte. Het team zelf blijft ongewijzigd.",
      "despawned": "{{name}} is uit de ruimte verwijderd",
      "despawnedTitle_one": "Verwijderd ({{count}})",
      "despawnedTitle_other": "Verwijderd ({{count}})"
    },
    "files": {
      "upload": "Uploaden",
      "newText": "Nieuw tekstbestand",
      "newTextDescription": "Agents kunnen tekstbestanden in deze ruimte lezen en bewerken.",
      "editDescription": "Opslaan met een bestaande naam vervangt dat bestand.",
      "readOnlyDescription": "Geëxtraheerde tekst (alleen lezen). Download het bestand voor het origineel.",
      "filename": "Bestandsnaam",
      "content": "Inhoud",
      "emptyTitle": "Nog geen bestanden",
      "emptyDescription": "Bestanden die je hier uploadt — en bestanden die de agents schrijven — worden met het hele team gedeeld.",
      "uploaded": "{{name}} geüpload",
      "saved": "{{name}} opgeslagen",
      "deleted": "{{name}} verwijderd",
      "download": "{{name}} downloaden",
      "downloadShort": "Downloaden",
      "delete": "{{name}} verwijderen",
      "deleteTitle": "Dit bestand verwijderen?",
      "deleteDescription": "{{name}} wordt voor het hele team verwijderd.",
      "deleteConfirm": "Bestand verwijderen",
      "status": {
        "pending": "Verwerken",
        "failed": "Extractie mislukt"
      }
    },
    "search": {
      "placeholder": "Zoeken in ruimtegegevens en bestanden…",
      "scope": "Zoeken in",
      "scopes": {
        "all": "Alles",
        "data": "Gegevens",
        "files": "Bestanden"
      },
      "noResults": "Niets gevonden voor “{{query}}”",
      "dataMeta": "{{chars}} tekens",
      "fileMeta": "Bestand",
      "dataTitle_one": "Ruimtegegevens ({{count}} sleutel)",
      "dataTitle_other": "Ruimtegegevens ({{count}} sleutels)",
      "dataEmpty": "Agents hebben nog geen gedeelde gegevens opgeslagen.",
      "browseFiles": "Bestanden bekijken"
    },
    "data": {
      "add": "Toevoegen",
      "addTitle": "Nieuw gegeven voor de ruimte",
      "description": "Gedeelde tekst die het team leest en schrijft met de tools voor ruimtegegevens. Waarden worden als platte tekst opgeslagen (JSON blijft letterlijk behouden).",
      "key": "Sleutel",
      "value": "Waarde",
      "valuePlaceholder": "Tekst, Markdown of JSON",
      "edit": "{{key}} bewerken",
      "delete": "{{key}} verwijderen",
      "deleteTitle": "Dit gegeven verwijderen?",
      "deleteDescription": "“{{key}}” wordt uit de ruimtegegevens verwijderd. Agents kunnen het niet meer lezen.",
      "deleteConfirm": "Gegeven verwijderen",
      "saved": "“{{key}}” opgeslagen",
      "deleted": "“{{key}}” verwijderd",
      "issues": {
        "keyRequired": "Vul een sleutel in.",
        "keyTooLong": "Een sleutel mag hoogstens {{keyMax}} tekens lang zijn.",
        "keyExists": "Deze sleutel bestaat al. Bewerk dat gegeven.",
        "valueTooLong": "Een waarde mag hoogstens {{valueMax}} tekens lang zijn.",
        "tooManyKeys": "Een ruimte kan hoogstens {{keysMax}} sleutels bevatten.",
        "totalTooLarge": "Alle waarden samen mogen hoogstens {{totalMax}} tekens lang zijn."
      }
    },
    "settings": {
      "title": "Instellingen van de ruimte",
      "description": "Wijzigingen gelden vanaf de volgende beurt.",
      "saved": "Instellingen opgeslagen",
      "name": "Naam",
      "instructions": "Instructies voor de ruimte",
      "instructionsHint": "Worden toegevoegd aan de instructies van elke medewerker in deze ruimte, bovenop de teaminstellingen.",
      "humanGate": "Mens in de lus",
      "hitlEnabled": "Vraag mij voordat het team verdergaat",
      "hitlEnabledHint": "De leider kan de beurt aan jou teruggeven als er input of goedkeuring nodig is.",
      "hitlCondition": "Wanneer vragen",
      "hitlConditionHint": "Optioneel, bijv. “voordat er iets naar een klant gaat”.",
      "budgets": "Limieten",
      "turnBudget": "Beurtbudget",
      "turnBudgetHint_one": "De ruimte stopt na dit aantal beurten ({{count}} gebruikt). Leeg betekent geen limiet.",
      "turnBudgetHint_other": "De ruimte stopt na dit aantal beurten ({{count}} gebruikt). Leeg betekent geen limiet.",
      "unlimited": "Onbeperkt",
      "turnsUnit": "beurten",
      "concurrency": "Parallelle medewerkers",
      "concurrencyHint": "Leden die tegelijk mogen werken (1–16).",
      "passBudget": "Leidersbeurten per run",
      "passBudgetHint": "Veiligheidslimiet op opeenvolgende leidersbeurten (1–200).",
      "contextMax": "Berichten in context",
      "contextMaxHint": "Hoeveel recente berichten agents zien (10–500).",
      "messagesUnit": "berichten",
      "compression": "Oudere berichten samenvatten",
      "compressionHint": "Houdt lange gesprekken samenhangend door oudere berichten in een doorlopende samenvatting te verwerken.",
      "compressionKb": "Samenvattingen ook in de kennisbank opslaan",
      "compressionKbHint": "Zo kunnen agents eerdere delen van het gesprek opzoeken.",
      "guardrails": "Regels",
      "guardrailsHint": "Eén regel per regel (max. 64). Elke medewerker moet zich eraan houden.",
      "sentry": "Sentry-organisatie",
      "sentryHint": "Optionele slug voor Sentry-tools in deze ruimte."
    }
  },
  "transcript": {
    "label": "Gesprek in de ruimte",
    "scrollToEnd": "Naar nieuwste scrollen",
    "loadEarlier_one": "{{count}} eerder bericht laden",
    "loadEarlier_other": "Eerdere berichten laden (nog {{count}})",
    "emptyTitle": "Geef het team een doel",
    "empty": "Beschrijf wat er moet gebeuren. De leider plant het werk en verdeelt het over het team.",
    "emptyPaused": "Beschrijf wat er moet gebeuren — je eerste bericht start de ruimte.",
    "you": "Jij",
    "system": "Systeem",
    "attachments": "Bijlagen",
    "to": "aan",
    "copy": "Bericht kopiëren",
    "reasoning": "Redenering",
    "thinking": "Denkt na…",
    "working": "{{name}} is bezig",
    "savedData": "Opgeslagen in ruimtegegevens: {{keys}}"
  }
}
